export default {
  ZH_HK: {
    gd: "廣東話",
    en: "英語",
    zn: "普通話",
    voice: "語音"
  },
  EN: {
    gd: "Cantonese",
    en: "English",
    zn: "Mandarin",
    voice: "Voice"
  },
  ZH_CN: {
    gd: "广东话",
    en: "英语",
    zn: "普通话",
    voice: "语音"
  },
  es: {
    gd: "Cantonés",
    en: "Inglés",
    zn: "Mandarín",
    voice: "Voz"
  }
};
